import { Link } from '@tanstack/react-router'

// Reusable NavLinks component
function Nav({ onClick }: { onClick?: () => void }) {
  return (
    <>
      <Link
        to="/contact"
        className="hover:text-link-hover-primary"
        onClick={onClick}
      >
        Contact us
      </Link>

      {/* External link */}
      <a
        href={window['OSS_URL']}
        className="btn btn-primary text-base"
        target="_blank"
        rel="noopener noreferrer"
        onClick={onClick}
      >
        My Broadband Account
      </a>
    </>
  )
}

export default Nav
